import { render, staticRenderFns } from "./DiagramPort.vue?vue&type=template&id=46485164&functional=true&"
import script from "./DiagramPort.vue?vue&type=script&lang=js&"
export * from "./DiagramPort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports